import React from 'react';
import ComunicadosView from '../Comunicados/ComunicadosView';
import NavigationSecurity from '../Layouts/Navigation/NavigationSecurity';

const ComunicadosSecurity = () => (
  <ComunicadosView
    role="seguridad"
    NavigationComponent={NavigationSecurity}
    accentColor="from-slate-600 to-gray-700"
  />
);

export default ComunicadosSecurity;
